// client/src/config/authConfig.js
//
// Minimal auth config for the self-hosted (cookie-session) auth. Replaces the
// keycloak-js config. Sessions live in httpOnly cookies, so there is no token
// for the SPA to hold — auth state is derived from GET /api/auth/me.

export const isAuthEnabled = () => import.meta.env.REACT_APP_AUTH_ENABLED === 'true';

export default { isAuthEnabled };
